/* global listBudgetsUrl downloadAttachmentUrl budgetDetailsUrl budgetUpdateUrl deleteAttachmentUrl versionsSummaryUrl compareBudgetsUrl editSnapshotUrl versionHistoryUrl canCreateBudgetVersion */

import React from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import BudgetsTable from './BudgetsTable';

function Budgets(props) {
    return (
        <BudgetsTable
            fetchUrl={listBudgetsUrl}
            summaryUrl={typeof versionsSummaryUrl !== 'undefined' ? versionsSummaryUrl : null}
            compareUrl={typeof compareBudgetsUrl !== 'undefined' ? compareBudgetsUrl : null}
            canCreateVersion={typeof canCreateBudgetVersion !== 'undefined' ? canCreateBudgetVersion : false}
            editSnapshotUrl={typeof editSnapshotUrl !== 'undefined' ? editSnapshotUrl : null}
            versionHistoryUrl={typeof versionHistoryUrl !== 'undefined' ? versionHistoryUrl : null}
            downloadUrl={downloadAttachmentUrl}
            detailsUrl={budgetDetailsUrl}
            updateUrl={budgetUpdateUrl}
            deleteAttachmentUrl={deleteAttachmentUrl}
        />
    );
}

export default Budgets;

if (document.getElementById('budgetsList')) {
    var rootEl = document.getElementById('budgetsList'); // data attributes below help us
    ReactDOM.render(
        <App>
            <Budgets />
        </App>,
        rootEl,
    );
}
